import {QueryCacheKeys} from '../../api/cache';
import {getProject} from '../../api/projects';
import {getTransactions} from '../../api/transactions';
import TransactionsTable from '../transactions/TransactionsTable';
import {useQuery} from '@tanstack/react-query';
import React, {useMemo} from 'react';
import {orderBy} from 'shared/src/list';

interface ProjectTransactionsProps {
	projectId: string;
}

const ProjectTransactions = ({projectId}: ProjectTransactionsProps) => {
	const {data: project} = useQuery({
		queryKey: QueryCacheKeys.project(projectId),
		queryFn: () => getProject(projectId),
	});

	const {data: transactions} = useQuery({
		queryKey: QueryCacheKeys.transactions({projectIds: [projectId]}),
		queryFn: () => getTransactions({projectIds: [projectId]}),
	});

	const sortedTransactions = useMemo(() => {
		return transactions && orderBy(transactions, 'date', 'desc');
	}, [transactions]);

	if (!project || !sortedTransactions) {
		return null;
	}

	return <TransactionsTable id={`project-${project.id}`} transactions={sortedTransactions} />;
};

export default ProjectTransactions;
